export enum NexusModule {
  Centrex = 'Centrex',
  MVNO = 'MVNO',
  Administrateur = 'Administrateur',
  Commande = 'Commande',
  Facture = 'Facture',
}

export const MODULE_TYPES: Record<NexusModule, 'application' | 'function'> = {
  [NexusModule.Centrex]: 'application',
  [NexusModule.MVNO]: 'application',
  [NexusModule.Administrateur]: 'function',
  [NexusModule.Commande]: 'function',
  [NexusModule.Facture]: 'function',
};
